import { cacheContext } from "../../caching/index.js";
import { hourMs } from "../../timeConstants.js";
import type { AssetIdentity } from "./assetIdentity.js";

export type AssetIdentityRecord = Pick<AssetIdentity, "verdiId" | "loraEui" | "assetType" | "assetCollection">;

/** Cached action that looks up an asset identity record by LoRa EUI.
 *  Long TTL is intentional — this data rarely changes and fast lookup reduces load times. */
export const assetIdentityByLoraEui = cacheContext.registerCachedAction<[string], AssetIdentityRecord | null>(
    "asset-identity-by-lora-eui",
    {
        ttlMs: 72 * hourMs,
        staleTtlMs: 24 * hourMs,
        // Read on every Device pre("validate"), ~600/min in production; 10% puts diagnostics
        // near 60 lines/min.
        diagnosticsSampleRate: 0.1,
    },
);
